<div class="h-min-full d-flex align-items-center" [class.dark-gray-bg]="showSubscribe"
  [class.yellow-bg]="!showSubscribe" [class.f-white]="showSubscribe">
  <div class="container-capped-sm text-center">
    <ng-container *ngIf="job && showSubscribe">
      <div class="rounded-xl p-2 fs-lg font-weight-bold mb-4">
        برای دیدن آگهی شما رو به
        <ng-container *ngIf="job.IsTelegram">کانال تلگرام</ng-container>
        <ng-container *ngIf="job.IsInstagram">صفحه اینستاگرام</ng-container>
        <ng-container *ngIf="!job.IsTelegram && !job.IsInstagram">سایت</ng-container>
        <span [attr.dir]="(job.IsTelegram || job.IsInstagram) ? 'ltr' : undefined"> {{job.SourceName}} </span>
        می‌فرستیم؛ ولی قبل رفتن
        <i class="fa fa-reply fs-xxl rotate--90 mt-3"></i>
      </div>
      <div class="white-bg f-initial rounded-xl shadow-kp mb-2 p-2 ">
        <app-subscribe-search class=" d-block  " [mode]="'redirect'" [source]="'redirect'" [params]="job.SearchParams"
          (subscribed)="redirect(true)">
        </app-subscribe-search>


      </div>
    </ng-container>
    <ng-container *ngIf="!showSubscribe">
      <h1 class="fs-normal font-weight-bold">
        داریم آگهی اصلی رو باز می‌کنیم.
        <br />
        از اونجا با کارفرما تماس بگیر.
      </h1>
      <div class="px-5 px-md-0">
        <img class="mw-100 my-2 my-md-4" src="/assets/images/bg/buffer.gif" alt="loading">
      </div>
    </ng-container>
    <div class="fs-normal mt-4">
      اگه مشکلی پیش اومد
      <span class="fw-bold pointer" *ngIf="job" [class.f-yellow]="showSubscribe" [class.f-blue]="!showSubscribe"
        (click)="redirect()">از اینجا آگهی اصلی رو ببین</span>
      یا <a [class.f-yellow]="showSubscribe" [class.f-blue]="!showSubscribe" [href]="referrer">از اینجا به کارپیشه
        برگرد</a>
    </div>
    <div *ngIf="job">
      (کد: {{job.Code}}) {{job.Title}}
    </div>
  </div>
</div>